export default __webpack_public_path__ + "static/media/documents.30489b77.png";